<template>
  <div>
    <div class="user-name">
      <h4 class="font-weight-medium">{{ fullName }}</h4>

      <span class="mob-none" @click="toggleEdit">
        <v-icon
          x-large
          class="icon-shape-1 display-22 v-align-text-top mr-2 pointer"
          color="primary"
        />
      </span>

      <span class="pc-none show-details" @click="toggleEdit">
        <span v-if="hideDetails" class="underline">
          {{ t(`titles.candidates.closeDetails`) }}
        </span>
        <span v-else class="underline">
          {{ t(`titles.candidates.personalDetails`) }}
        </span>
        <v-icon
          x-large
          v-if="!hideDetails"
          class="icon-shape-1 display-22 v-align-text-top"
          color="primary"
        />
      </span>
    </div>
    <div class="mob-none">
      <div class="display-18">
        <span class="user-city">
          {{ t(`titles.candidates.cityTitle`) }} : {{ location }}
        </span>
        |
        <span class="user-email">
          {{ t(`titles.candidates.emailTitle`) }}: {{ email }}
        </span>
        |
        <span class="user-phone">
          {{ t(`titles.candidates.phoneTitle`) }}: {{ phoneNum }}
        </span>
        |
        <span class="user-birth">
          {{ t(`titles.candidates.birthDateTitle`) }}: {{ birthYear }}
        </span>
        |
        <span class="user-last-job">
          {{ t(`titles.candidates.lastJobTitle`) }}:

          {{
            lastPosition === 'לא רלוונטי' || lastPosition === ''
              ? 'לא צוין'
              : lastPosition
          }}
        </span>
        |
        <span class="user-last-experience">
          {{ t(`titles.candidates.experienceTitle`) }}: {{ experience }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CurrentUser from '@/components/mixins/CurrentUser';

export default {
  mixins: [CurrentUser],
  data() {
    return {
      cvSendModel: null,
      hideDetails: false,
    };
  },
  computed: {
    ...mapState({
      busy: (state) => state.auth.busy,
      auth: (state) => state.auth,
    }),
    userProfile() {
      return this.CurrentUser;
    },
    phoneNum() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.Phone
        ? this.userProfile.Profile.Phone
        : '';
    },

    location() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.Location
        ? this.userProfile.Profile.Location.City
        : '';
    },

    lastPosition() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.LastPosition
        ? this.userProfile.Profile.LastPosition
        : '';
    },

    experience() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.Experience
        ? this.userProfile.Profile.Experience.Name
        : '';
    },

    birthYear() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.BirthYear
        ? this.userProfile.Profile.BirthYear.toString()
        : '';
    },
    email() {
      return this.userProfile && this.userProfile.Email
        ? this.userProfile.Email.toString()
        : '';
    },
    fullName() {
      return this.userProfile && this.userProfile.FullName
        ? this.userProfile.FullName.toString()
        : '';
    },
  },
  methods: {
    /***
     * Toggle user detail edit form
     *  @param {Number} set the selected tab on the next open to the first - 0
     */
    toggleEdit() {
      this.hideDetails = !this.hideDetails;
      this.$nuxt.$emit('toggleEditForm', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-name {
  padding: 0 10px 10px;
}

.user-name h4 {
  display: inline-flex;
}

.user-details {
  padding: 0 10px;
}

.show-details {
  float: left;
}

.mob-none {
  display: none;
}

.user-fav-job {
  display: flex;
}

@media only screen and (min-width: 600px) {
  .user-name {
    padding: 0;
  }

  #user-details-box {
    padding: 16px 16px;
  }

  .mob-none {
    display: inline-flex;
  }

  .pc-none {
    display: none;
  }
}
</style>
